/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const reputationCandidateSchema = z.object({ "calculatedDisplayName": z.string().nullish(), "calculatedFirstName": z.string().nullish(), "calculatedLastName": z.string().nullish(), "id": z.string().uuid() });
export type ReputationCandidate = z.infer<typeof reputationCandidateSchema>;
